import { motion } from "framer-motion";

export const Splash = ({ className = "", color = "#0066FF", delay = 0 }) => (
  <motion.svg
    aria-hidden="true"
    viewBox="0 0 200 200"
    className={`pointer-events-none absolute -z-10 blur-2xl ${className}`}
    initial={{ opacity: 0, scale: 0.8 }}
    whileInView={{ opacity: 0.35, scale: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 1.2, delay, ease: "easeOut" }}
  >
    <path
      fill={color}
      d="M43.9,-64.8C56.3,-56.4,65.6,-43.9,70.9,-29.7C76.2,-15.6,77.5,0.3,72.9,14.2C68.3,28.1,57.8,40,45.6,49.7C33.4,59.4,19.5,66.9,3.9,71.2C-11.7,75.5,-29,76.6,-42.7,69.8C-56.4,63,-66.5,48.3,-71.6,32.6C-76.7,16.9,-76.8,0.2,-72.4,-14.8C-68,-29.8,-59.1,-43.1,-46.8,-51.7C-34.5,-60.3,-18.8,-64.2,-2.3,-61C14.2,-57.8,31.5,-47.6,43.9,-64.8Z"
      transform="translate(100 100)"
    />
  </motion.svg>
);

export const MapPath = ({ className = "" }) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 100 400"
    preserveAspectRatio="none"
    className={`pointer-events-none absolute -z-10 ${className}`}
  >
    <path
      d="M50,0 C80,60 20,120 50,180 C80,240 20,300 50,400"
      fill="none"
      stroke="#0066FF"
      strokeWidth="2.5"
      strokeDasharray="2 12"
      strokeLinecap="round"
      opacity="0.35"
    />
  </svg>
);

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);
